<template>
  <div class="form-control" ref="formControl">
    <div class="top-container" ref="ddd">
      <div class="left">
        <i class="el-icon-arrow-left" @click="toPreliminary"></i>
      </div>
      <div class="center">
        <div
          :class="{ active: activeMenuIndex == index }"
          v-for="(item, index) in activelist"
          :key="index"
          @click="switchMenu(item.id, index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="right">
        <!-- <el-button class="btn-blue">预览</el-button> -->
        <el-button plain class="btn-white" @click="release">发布</el-button>
      </div>
    </div>
    <!-- 表单设计 -->
    <div v-if="isActive == 1" class="container">
      <div class="left-container drop">
        <div
          class="row"
          v-for="(item, index) in this.FORM_CONTROL_LIST"
          :key="index"
        >
          <div class="form-title">{{ item.title }}</div>
          <div class="control">
            <div
              class="control-details"
              v-for="(value, i) in item.list"
              :key="i"
              @mousedown.stop="getDropItem(value, $event)"
            >
              <span>{{ value.name }}</span>
              <img :src="value.img" />
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="phone">
          <div class="inset-phone">
            <div class="title">
              <div class="title-name">
                <p v-if="isMod">{{ title }}</p>
                <el-input
                  v-else
                  class="gray white"
                  v-model="title"
                  autofocus
                  @blur="blur"
                ></el-input>
              </div>
              <img src="../../../assets/mod.png" @click="mod" />
            </div>
            <div class="inside-nothing" v-if="allComponent.length == 0">
              <img class="img" src="../../../assets/form/bottom-arrow.png" />
              <p>选择左侧控件，拖动到此处</p>
            </div>
            <div class="content" v-else>
              <div
                :class="
                  activeIndex === index
                    ? 'component-container-active component-container'
                    : 'component-container'
                "
                v-for="(item, index) in allComponent"
                :key="index"
                @click="selectComponent(item, index)"
                @mousemove="mousemove(index)"
              >
                <div
                  :class="
                    activeIndex === index ? 'remove removeActive' : 'remove'
                  "
                  @click="remove(index)"
                >
                  x
                </div>
                <component
                  :is="item.htmlContent"
                  :name="item.name[0].value"
                  :placeholder="item.placeholder[0].value"
                  :required="item.required"
                  :isSelect="item.isSelect"
                  :fartherIndex="index"
                  :fartherActiveIndex="activeIndex"
                  :list="item.list"
                  :startTime="item.dateRange[0].value"
                  :endTime="item.dateRange[1].value"
                  :durationTime="item.dateRange[2].value"
                ></component>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container" v-if="isOpenRightContainer && allComponent.length > 0">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <div class="controlTitleName">{{ form.controlTitleName }}</div>
          <el-form-item label="控件名称" prop="name" v-if="form.type !== 'dateRange'">
            <el-input class="gray white" v-model="form.name" @blur="nameBlur"></el-input>
          </el-form-item>
          <el-form-item label="控件名称" prop="startTime" v-if="form.type === 'dateRange'">
            <el-input class="gray white" v-model="form.startTime" @blur="startTimeBlur"></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.type === 'dateRange'"
            label="控件名称"
            prop="endTime"
          >
            <el-input class="gray white" v-model="form.endTime" @blur="endTimeBlur"></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.type === 'dateRange'"
            label="控件名称"
            prop="duration"
          >
            <el-input class="gray white" v-model="form.duration" @blur="durationBlur"></el-input>
          </el-form-item>
          <el-form-item
            v-if="isPlaceholder"
            label="提示文字"
            prop="placeholder"
          >
            <el-input class="gray white" v-model="form.placeholder" @blur="blurPlaceholder"></el-input>
          </el-form-item>
          <el-form-item
            v-if="form.type === 'img'"
            label="上传数量"
            prop="uploadNum"
          >
            <el-input class="gray white" v-model="form.uploadNum"></el-input>
          </el-form-item>

          <div class="radio" v-if="form.type === 'radio'">
            <div class="radio-title">
              <span>选项</span>
              <span class="star">*</span>
            </div>
            <el-form-item
              v-for="(domain, index) in form.radioList"
              :key="index"
              :prop="'radioList.' + index + '.value'"
              :rules="{
                required: true,
                message: '单选控件没有选项，请添加',
                trigger: 'blur',
              }"
            >
              <div class="radio-container">
                <el-input v-model="domain.value"></el-input>
                <i
                  v-if="index > 0"
                  class="el-icon-close"
                  @click.prevent="removeDomain(index)"
                ></i>
              </div>
            </el-form-item>
            <div class="add-radio">
              <el-button
                type="text"
                class="btn-text"
                icon="el-icon-plus"
                @click="addDomain"
                >添加选项</el-button
              >
            </div>
          </div>
          <div v-if="isOpenOther">
            <div class="other-title">其他可选</div>
            <div class="required">
              <el-form-item prop="checked">
                <el-checkbox v-model="form.checked" @change="changeIsRequired"
                  >必填</el-checkbox
                >
              </el-form-item>
              <el-form-item
                prop="durationChecked"
                v-if="form.type === 'dateRange'"
              >
                <el-checkbox v-model="form.durationChecked"
                  >时长允许修改</el-checkbox
                >
              </el-form-item>
              <!-- <el-form-item
                prop="location"
                v-if="form.type === 'addressSelect'"
              >
                <el-checkbox v-model="form.location">自动定位</el-checkbox>
              </el-form-item> -->
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 打印编辑器 -->
    <div v-else class="print-container">
      <div class="print-content">
        <div class="print-top">
          <div class="print-top-left">
            <div class="print-upload-title">上传模板：</div>
            <el-upload
              class="upload"
              ref="upload"
              action="#"
              :class="images.length < 1 ? '' : 'none'"
              :limit="1"
              :on-exceed="handleLimit"
              :on-remove="onRemove"
              :before-upload="beforeUpload"
              :auto-upload="true"
              :file-list="fileList"
            >
              <i class="el-icon-plus"></i>
              <div v-if="fileList.length == 0" slot="tip" class="el-upload__tip">{{ uploadTips }}</div>
            </el-upload>
          </div>
          <div class="print-top-right" @click="rotate">
            <img src="../../../assets/form/rotate.png" />
            <span>旋转</span>
          </div>
        </div>
        <div class="print-main">
          <div class="print-main-left" ref="printLeft" style="width: 190px;">
            <vue-drag-resize
              class="print-title-row"
              v-for="(item, index) in titleList"
              :key="index"
              :w="item.vw"
              :h="item.vh"
              :x="item.vx"
              :y="item.vy"
              :z="999"
              @resizestop="resizestop($event, index)"
              @dragstop="dragging($event, index)"
            >
              {{ item.name }}
            </vue-drag-resize>
          </div>
          <div class="print-main-right">
            <div class="print-img" v-if="printImg" ref="printSize">
              <img :src="printImg" ref="rotate"/>
            </div>
            <div class="print-nothing" v-else>
              <img class="img" src="../../../assets/form/bottom-arrow.png" />
              <p>选择左侧控件，拖动到此处</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Sortable from "sortablejs";
import VueDragResize from "vue-drag-resize";
import { formControlMixins } from "@/common/mixins/form/form-control.js";
import { checkIn, generateMixed } from "@/common/js/utils.js";
import ImgUploader from "@/models/img-upload.js";
const imgUploader = new ImgUploader();
import BillAdmin from "@/models/bill-admin.js";
export default {
  mixins: [formControlMixins],
  components: {
    VueDragResize,
  },

  data() {
    return {
      typeId: null,
      secondTypeId: null,
      officialType: '',
      isActive: 1,
      activeMenuIndex: 0,
      activelist: [
        { id: 1, name: "表单设计" },
        { id: 2, name: "打印编辑器" },
      ],
      isMod: true,
      title: "出差审批单",
      activeIndex: null,
      allComponent: [],
      selectDroplist: null,
      form: {
        type: "",
        controlTitleName: "",
        name: "",
        placeholder: "",
        startTime: "",
        endTime: "",
        duration: "",
        checked: true,
        durationChecked: true,
        // location: true,
        uploadNum: "",
        radioList: [{ value: "", key:generateMixed(9) }],
      },
      rules: {
        name: [{ required: true, message: "请输入控件名称", trigger: "blur" }],
        startTime: [
          { required: true, message: "请输入控件名称", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入控件名称", trigger: "blur" },
        ],
        duration: [
          { required: true, message: "请输入控件名称", trigger: "blur" },
        ],
        uploadNum: [
          { required: true, message: "请输入上传数量", trigger: "blur" },
        ],
      },
      isOpenRightContainer: false,
      isPlaceholder: true,
      isOpenOther: true,
      selectObj: {},
      isSelectObj: false,

      /* ----  以下是打印编辑器字段  --------- */
      uploadTips: "最多上传1个，支持png、jpg形式",
      images: [],
      fileList: [],
      titleList: [],
      // 图片旋转角度
      deg: 0, 
      printImg: '',
      // 图片移动的x坐标
      transformLeft: 0,
      // 图片移动的Y坐标
      transformTop: 0,
      timerId: null
    };
  },

  async created() {
    config()
    this.typeId = this.$route.query.typeId
    this.title = this.$route.query.title
    this.officialType = this.$route.query.officialType
    if (this.officialType == 'BizTripTrial') {
      this.secondTypeId = 5
    } else if(this.officialType == 'WithoutOfficialCard') {
      this.secondTypeId = 4
    } else if(this.officialType == '') {
      this.secondTypeId = 2
    } else if(this.officialType == 1) {
      this.secondTypeId = 3
    } else if(this.officialType == 2) {
      this.secondTypeId = 1
    }
    if (this.secondTypeId == 2) {
      this._getPreliminaryDetails()
      await this.initPrintContralCustomList()
      this.activelist = [
        { id: 1, name: "表单设计" },
        { id: 2, name: "打印编辑器" },
      ]
    } else if (this.secondTypeId == 5) {
      this.isActive = 2,
      this.activelist = [
        { id: 2, name: "出差审批单打印编辑器" },
        { id: 3, name: "同行人员打印编辑器" },
      ]
      await this.initTitleList()
    } else {
      this.isActive = 2,
      this.activelist = [
        { id: 2, name: "打印编辑器" },
      ]
      await this.initTitleList()
    }
    await this.initPrintDetails()
    
  },
  mounted() {
    if (this.secondTypeId != 2) {
      this.initCount()
    }
    this.drag();
    this.$bus.on("isFatherActiveIndex", (v, row) => {
      this.activeIndex = v;
      this.openForm(row);
    });
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },

  methods: {
    /* 打印除自定义预审批单控件列表 */
    async initTitleList() {
      // // vw: 160, vh: 36, vx: 35, vy: 109
      let defaultVx
      let defaultVy
      if (this.secondTypeId != 2) {
        defaultVx = 15 
        defaultVy = -36
      } else {
        let lenght = this.titleList.length-1
        defaultVx = this.titleList[lenght]?this.titleList[lenght].vx:15
        defaultVy = this.titleList[lenght]?this.titleList[lenght].vy:-36
      }
      let type = this.secondTypeId
      let typeId = this.typeId ? this.typeId: ''
      let res = await BillAdmin.getPrintContralList(type, typeId)
      if (res.success) {
        let arr = []
        res.result.map(i => {
          let obj = {}
          defaultVy +=  46
          obj.keyword = i.keyword
          obj.name = i.name
          obj.vw = 150
          obj.vh = 36
          obj.vx = defaultVx
          obj.vy = defaultVy
          obj.topSpot = []
          obj.rightSpot = []
          obj.bottomSpot = []
          obj.leftSpot = []
          obj.isFixed = 1
          arr.push(obj)
        })
        if (this.secondTypeId != 2) {
          this.titleList = arr
        } else {
          this.titleList = this.titleList.concat(arr)
        }
      } else {
        this.$message({
          type: 'error',
          message: res.message
        });
      }
    },

    /* 打印自定义预审批单控件列表 */
    async initPrintContralCustomList() {
      // // vw: 160, vh: 36, vx: 35, vy: 145 
      let defaultVx = 15
      let defaultVy = -36
      let formId = this.typeId
      let res = await BillAdmin.getPrintContralCustomList(formId)
      if (res.success) {
        let { controlList, translateList } = res.result
        let arr2 = ["dateRange"]
        function filterFnc(v) {
          let valueObj = translateList.filter(item => {
            return item.key == v 
          })
          return valueObj[0].value
        }
        let arr = []
        controlList.map(i => {
          let obj = {}
          obj.controlId = i.id
          if (arr2.indexOf(i.type) !== -1) {
            obj.name = '日期区间'
          } else {
            obj.name = filterFnc(i.name)
          }
          defaultVy +=  46
          obj.keyword = i.type
          obj.vw = 150
          obj.vh = 36
          obj.vx = defaultVx
          obj.vy = defaultVy
          obj.topSpot = []
          obj.rightSpot = []
          obj.bottomSpot = []
          obj.leftSpot = []
          obj.isFixed = 0
          arr.push(obj)
        })
        this.titleList = arr
        await this.initTitleList()
      } else {
        this.$message({
          type: 'error',
          message: res.message
        });
      }
    },

    /* 打印详情 */
    async initPrintDetails() {
      let options
      let type = this.secondTypeId
      let typeId = this.typeId
      if (type != 6) {
        options = {
          type,
          typeId
        }
      } else {
        options = {
          type
        }
      }
      let res = await BillAdmin.getPrintDetails(options)
      if (res.success) {
        let {basicPic, printTemplateCoordinateList} = res.result
        this.printImg = basicPic 
        let arr = []
        let offsetTop = 155
        let offsetLeft = 210
        if (printTemplateCoordinateList) {
          printTemplateCoordinateList.map(i => {
            let obj = {}
            obj.controlId = i.controlId
            if (i.controlId) {
              obj.isFixed = 0
            } else {
              obj.isFixed = 1
            }
            obj.vx = i.minX+offsetLeft
            obj.vy = i.minY+offsetTop
            obj.keyword = i.keyword
            obj.name = i.controlName
            obj.vw = i.maxX - i.minX
            obj.vh = i.maxY - i.minY
            obj.topSpot = [i.minX+offsetLeft, i.minY+offsetTop]
            obj.rightSpot = []
            obj.bottomSpot = [i.maxX+offsetLeft, i.maxY+offsetTop]
            obj.leftSpot = []
            arr.push(obj)
          })
          this.titleList = this.titleList.concat(arr)
        }
      } else {
        this.$message({
          type: 'error',
          message: res.message
        });
      }
    },
    
    savePrint() {
      // let offsetTop = this.$refs.printSize.offsetTop
      // let offsetLeft = this.$refs.printSize.offsetLeft
      let offsetTop = 155
      let offsetLeft = 210
      let basicPic = this.printImg
      let type = this.secondTypeId
      let typeId = this.typeId
      let printTemplateCoordinateList = []
      this.titleList.map(i => {
        if (i.topSpot.length > 0) {
          let obj = {}
          obj.controlName = i.name
          obj.minX = i.topSpot[0] - offsetLeft
          obj.minY = i.topSpot[1] - offsetTop
          obj.maxX = i.bottomSpot[0]- offsetLeft
          obj.maxY = i.bottomSpot[1]- offsetTop
          if (this.secondTypeId == 2) {
            obj.controlId = i.controlId
            if (i.isFixed) {
              obj.keyword = i.keyword
            }
          } else {
            obj.keyword = i.keyword
          }
          printTemplateCoordinateList.push(obj)
        }
      })
      let data
      if (this.secondTypeId !== 6) {
        data = {
          basicPic,
          type,
          typeId,
          printTemplateCoordinateList
        }
      } else {
        data = {
          basicPic,
          type,
          printTemplateCoordinateList
        }
      }
      BillAdmin.postSavePrint(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '发布成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 计算宽高 */
    initCount() {
      this.timerId = setTimeout(() => {
        let clientWidth = document.body.clientWidth
        if (this.isActive != 1 && clientWidth < 1920) this.$refs.formControl.style.width =1920+ "px"
        let height = document.body.scrollHeight
        let lgh = this.titleList.length
        let printLeftHeight = ((lgh*46)+36) < height?height+ "px":((lgh*46)+36)+ "px"
        if (this.$refs.printLeft) this.$refs.printLeft.style.height = printLeftHeight
      },800)
    },

    async switchMenu(id, index) {
      if (id != 1) {
        this.initCount()
      } else {
        let clientWidth = document.body.clientWidth
        this.$refs.formControl.style.width =clientWidth+ "px"
      }
      this.isActive = id;
      if (id == 3) {
        this.secondTypeId = 6
        this.printImg = ''
        this.images = []
        this.fileList = []
      } else {
        if (this.officialType == 'BizTripTrial') {
          this.secondTypeId = 5
        }
      }
      if (id == 1) {
        this.$nextTick(() => {
          this.drag();
        })
      }
      
      if (this.secondTypeId == 2) {
        await this.initPrintContralCustomList()
      } else {
        await this.initTitleList()
      }
      this.activeMenuIndex = index;
      await this.initPrintDetails()
    },

    toPreliminary() {
      this.$router.go(-1);
    },

    mod() {
      this.isMod = false;
    },

    blur() {
      this.isMod = true;
    },

    /* 获取拖拽的数据 */
    getDropItem(v, e) {
      this.selectDroplist = v;
    },

    drag() {
      const nodes = document.querySelectorAll(".drop > .row > .control");
      const _this = this;
      let arr = [...nodes];
      arr.map((i) => {
        Sortable.create(i, {
          group: {
            name: "shared",
            pull: "clone",
            put: false,
          },
          sort: false,
          disabled: false, // 拖拽不可用? false 启用
          ghostClass: "sortable-ghost", //拖拽样式
          animation: 150, // 拖拽延时，效果更好看
          onEnd: (e) => {
            // 拖拽结束时的触发
            let obj = {};
            obj.htmlContent = _this.selectDroplist.htmlContent;
            obj.name = [{
              value: _this.selectDroplist.name,
              key: generateMixed(9)
            }];
            obj.placeholder = [{
              value: _this.selectDroplist.placeholder,
              key: generateMixed(9)
            }];
            obj.dateRange = [
              {
                key: generateMixed(9),
                value: _this.selectDroplist.startTime
              },
              {
                key: generateMixed(9),
                value: _this.selectDroplist.endTime
              },
              {
                key: generateMixed(9),
                value: _this.selectDroplist.durationTime
              },
            ]
            obj.required = _this.selectDroplist.required;
            obj.isSelect = _this.selectDroplist.isSelect;
            obj.type = _this.selectDroplist.type;
            if (_this.selectDroplist.type == 'radio') obj.radioList = [{ value: "", key: generateMixed(9) }]
            if (obj.type === "container") {
              obj.list = [];
            }
            _this.allComponent.push(obj);
            this.$nextTick(() => {
              const eitorELement =
                document.querySelectorAll("#container > .row");
              let ee = [...eitorELement];
              ee.map((i) => {
                if (checkIn(i, window.event.clientX, window.event.clientY)) {
                  let length = _this.allComponent.length - 1;
                  _this.isSelectObj = true;
                  _this.selectObj = obj;
                  if (obj.type !== "container") {
                    _this.allComponent.splice(length, 1);
                  }
                }
              });
            });
          },
        });
      });
    },

    mousemove(index) {
      if (this.isSelectObj && this.selectObj.type != "container") {
        this.allComponent[index].list.push(this.selectObj);
        this.isSelectObj = false;
      }
    },

    /* 选中组件 */
    selectComponent(row, index) {
      /* 高亮删除框逻辑 */
      const eitorELement = document.querySelector(
        "#container > .row > .container-content"
      );
      if (eitorELement && checkIn(eitorELement)) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
      this.openForm(row);
    },

    openForm(row) {
      this.isOpenRightContainer = true;
      this.form.type = row.type;
      this.form.controlTitleName = row.name.value;
      this.form.placeholder = row.placeholder.value;
      this.form.checked = row.required;
      let arr = ["img", "enclosure", "agentText", "levelText", "cost"];
      let arr2 = ["agentText", "levelText"];
      if (arr.indexOf(row.type) !== -1) {
        this.isPlaceholder = false;
      } else {
        this.isPlaceholder = true;
      }
      if (arr2.indexOf(row.type) !== -1) {
        this.isOpenOther = false;
      } else {
        this.isOpenOther = true;
      }
      if (row.type === 'radio') {
        this.form.radioList = row.radioList
      }
      if (row.type === "dateRange") {
        this.form.startTime = row.dateRange[0].value;
        this.form.endTime = row.dateRange[1].value;
        this.form.duration = row.dateRange[2].value;
        this.form.placeholder = row.placeholder[0].value;
      } else {
        this.form.name = row.name[0].value;
        this.form.placeholder = row.placeholder[0].value;
      }
    },

    /* 添加选项 */
    addDomain() {
      this.form.radioList.push({
        value: "",
        key: generateMixed(9)
      });
    },

    /* 删除选项 */
    removeDomain(index) {
      this.form.radioList.splice(index, 1);
    },

    /* 是否必填 */
    changeIsRequired(v) {
      this.form.checked = v;
      this.allComponent[this.activeIndex].required = v;
    },

    /* 删除控件 */
    remove(index) {
      this.allComponent.splice(index, 1);
      if (this.allComponent.length == 0) {
        this.activeIndex = null
        this.isOpenRightContainer = false
        this.form.type = ''
      }
    },

    nameBlur() {
      this.allComponent[this.activeIndex].name[0].value = this.form.name
    },
    startTimeBlur() {
      this.allComponent[this.activeIndex].dateRange[0].value = this.form.startTime
    },
    endTimeBlur() {
      this.allComponent[this.activeIndex].dateRange[1].value = this.form.endTime
    },
    durationBlur() {
      this.allComponent[this.activeIndex].dateRange[2].value = this.form.duration
    },
    blurPlaceholder() {
      this.allComponent[this.activeIndex].placeholder[0].value = this.form.placeholder
    },

    release() {
      if (this.isActive == 1) {
        let data = {}
        data.name = this.title
        data.id = this.typeId
        data.controlList = []
        data.translateList = []
        let arr = ["text", "textarea", "numText","date", "addressSelect", "amountText", "enclosure", "img", "radio", "agentText", "levelText"];
        let arr2 = [ "enclosure", "img", "agentText", "levelText"]
        let controlList = []
        let translateList = []
        this.allComponent.map((i, index) => {
          let obj = {}
          obj.isRequst = i.required
          obj.type = i.type
          obj.controlId = i.controlId
          obj.sort = index+1
          if (i.type != 'dateRange') {
            obj.placeholder = i.placeholder[0].key
          } else {
            obj.placeholder = ''
          }
          if (arr2.indexOf(i.type) !== -1) {
            obj.placeholder = ''
          } else {
            translateList.push(...i.placeholder)
          }
          if (arr.indexOf(i.type) !== -1) {
            obj.name = i.name[0].key
            obj.value = ''
            translateList.push(...i.name)
          } 
          if (i.type == 'dateRange') {
            obj.name = ''
            obj.value = {
              "start": {'value': '','name': i.dateRange[0].key, 'placeholder': i.placeholder[0].key},
              "end": {'value': '','name': i.dateRange[1].key, 'placeholder': i.placeholder[0].key},
              "days": {'value': '','name': i.dateRange[2].key, 'placeholder': i.placeholder[0].key},
              "modifyDaysFlag": this.form.durationChecked ? 1 : 0
            }
            translateList.push(...i.dateRange)
          }
          if (i.type == 'radio') {
            obj.value = {
              options: []
            }
            i.radioList.map((item, index) => {
              let radioObj = {}
              radioObj.value = item.key
              if (index == 0) {
                radioObj.isSelected = true
              } else {
                radioObj.isSelected = false
              }
              obj.value.options.push(radioObj)
            })
            translateList.push(...i.radioList)
          }
          if (i.type == 'enclosure' || i.type == 'img') {
            obj.value = {
              'limit': this.form.uploadNum,
              'value': ''
            }
          }
          if (i.type == 'addressSelect') {
            obj.value = {
              'province': {'code': '', 'value': ''},
              'city': {'code': '', 'value': ''},
              'district': {'code': '', 'value': ''},
            }
          }
          controlList.push(obj)
        })
        data.controlList = controlList
        data.translateList = translateList
        BillAdmin.postModPreliminary(data).then(res => {
          if (res.success) {
            this.$notify({
              title: '发布成功',
              message: '请前往打印模板设置'
            });
            this._getPreliminaryDetails()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      } else {
        this.savePrint()
      }
    },

    /* 获取预审批单详情 */
    _getPreliminaryDetails() {
      let id = this.typeId
      BillAdmin.getPreliminaryDetails(id).then(res => {
        if (res.success) {
          this.title = res.result.name
          let { controlList, translateList } = res.result
          let arr = ["text", "textarea", "numText", "amountText", "date", "addressSelect"]
          let arr2 = ["dateRange"]
          let arr3 = ["img", "enclosure"]
          let arr4 = ["agentText", "levelText"]
          let arr5 = ["radio"]
          function filterFnc(v) {
            let valueObj = translateList.filter(item => {
              return item.key == v 
            })
            return valueObj.length > 0 ? valueObj[0].value : ''
          }
          let allComponent = []
          let isDateRange = false
          controlList.map(i => {
            let obj = {}
            obj.controlId = i.id
            if (arr.indexOf(i.type) !== -1) {
              obj.htmlContent = 'TextComponent'
              obj.name = [{
                'key': i.name,
                'value': filterFnc(i.name)
              }]
              obj.placeholder = [{
                'key': i.placeholder,
                'value': filterFnc(i.placeholder)
              }]
            }
            if (arr2.indexOf(i.type) !== -1) {
              isDateRange = true
              obj.htmlContent = 'DateRange'
              obj.value = JSON.parse(i.value)
              obj.name = [{
                'key': i.name,
                'value': ''
              }]
                obj.placeholder = [{
                  'key': i.placeholder,
                  'value': filterFnc(obj.value.start.placeholder)
                }]
                obj.dateRange = [
                  {
                    'key': obj.value.start.name,
                    'value': filterFnc(obj.value.start.name)
                  },
                  {
                    'key': obj.value.end.name,
                    'value': filterFnc(obj.value.end.name)
                  },
                  {
                    'key': obj.value.days.name,
                    'value': filterFnc(obj.value.days.name)
                  },
                ]
                this.form.durationChecked = obj.value.modifyDaysFlag == 1 ? true : false
            }
            if (arr3.indexOf(i.type) !== -1) {
              obj.htmlContent = 'UploadComponent'
              obj.name = [{
                'key': i.name,
                'value': filterFnc(i.name)
              }]
              obj.placeholder = [{
                'key': i.placeholder,
                'value': ''
              }]
              let valueObj = JSON.parse(i.value)
              if (valueObj) {
                this.form.uploadNum = valueObj.limit
              }
            }
            if (arr4.indexOf(i.type) !== -1) {
              obj.htmlContent = 'TextComponent'
              obj.name = [{
                'key': i.name,
                'value': filterFnc(i.name)
              }]
              obj.placeholder = [{
                'key': i.placeholder,
                'value': ''
              }]
            }
            if (arr5.indexOf(i.type) !== -1) {
              obj.htmlContent = 'TextComponent'
              obj.name = [{
                'key': i.name,
                'value': filterFnc(i.name)
              }]
              obj.placeholder = [{
                'key': i.placeholder,
                'value': i.placeholder?filterFnc(i.placeholder):''
              }]
              obj.value = JSON.parse(i.value)
              let radioList = []
              if (obj.value) {
                obj.value.options.map(item => {
                  let radioListObj = {}
                  radioListObj.key = item.value
                  radioListObj.value = filterFnc(item.value)
                  radioList.push(radioListObj)
                })
              }
              obj.radioList = radioList
            }
            obj.sort = i.sort
            obj.required = i.isRequst
            obj.isSelect = i.isRequst
            obj.type = i.type
            allComponent.push(obj)
          })
          

          if (isDateRange) {
            let dateRange = []
            allComponent.map(i => {
              if (i.htmlContent == 'DateRange') {
                dateRange = i.dateRange
              }
            })
            allComponent.map(i => {
              i.dateRange = dateRange
            })
          } else {
            let dateRange = [
              {
                'key': '',
                'value': ''
              },
              {
                'key': '',
                'value': ''
              },
              {
                'key': '',
                'value': ''
              },
            ]
            allComponent.map(i => {
              i.dateRange = dateRange
            })
          }
          this.allComponent = allComponent
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },


    /* -------------  以下是打印编辑器字段  --------- */
    /* 图片数量大于1 */
    handleLimit() {
      this.$message({
        message: "图片数量最多1张",
        type: "warning",
      });
    },

    /* 删除图片 */
    onRemove(file, fileList) {
      this.fileList = fileList;
      this.images = [];
      this.fileList.map((value, index, Array) => {
        this.images.push(value.url);
      });
    },

    /* 上传图片进行判断图片 */
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(async (res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.url = res.imgUrl;
              obj.name = res.name
              this.fileList.push(obj);
              this.images = [];
              this.fileList.map((value, index, Array) => {
                this.images.push(value.url);
              });
              
              if (this.secondTypeId == 2) {
                await this.initPrintContralCustomList()
              } else {
                await this.initTitleList()
              }

              await this.initPrintDetails()
              this.printImg = await this.images[0]

              await this.initCount()
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },

    /* 旋转图片 */
    rotate() {
      let left = this.$refs.rotate.width
      let top = this.$refs.rotate.height
      this.deg += 90;
      if (this.deg >= 360) {
        this.deg = 0;
        this.transformLeft = 0
        this.transformTop = 0
        this.$refs.printSize.style.height = `${top}px`
      } else if (this.deg == 90) {
        this.transformLeft = 0
        this.transformTop = `-${top}`
        this.$refs.printSize.style.height = `${left}px`
      } else if(this.deg == 180) {
        this.transformLeft = `-${left}`
        this.transformTop = `-${top}`
        this.$refs.printSize.style.height = `${top}px`
      } else if(this.deg == 270) {
        this.transformLeft = `-${left}`
        this.transformTop = 0
        this.$refs.printSize.style.height = `${left}px`
      }
      this.$refs.rotate.style.transform = `rotate(${this.deg}deg) translate(${this.transformLeft}px,${this.transformTop}px)`;
      this.$refs.rotate.style.transformOrigin = `left top`;
    },
    /* 缩放结束事件 */
    resizestop(e, index) {
      this.calculateCoordinates(e, index)
    },
    /* 拖拽结束事件 */
    dragging(e, index) {
      this.calculateCoordinates(e, index)
    },
    /* 计算四个点的坐标 */
    calculateCoordinates(e, index) {
      let topSpot = [e.left,e.top]
      let rightSpot = [e.left+e.width, e.top]
      let bottomSpot = [e.left+e.width, e.top+e.height]
      let leftSpot = [e.left,e.top+e.height]
      this.titleList[index].topSpot = topSpot
      this.titleList[index].rightSpot = rightSpot
      this.titleList[index].bottomSpot = bottomSpot
      this.titleList[index].leftSpot = leftSpot
    },
  },
};
</script>

<style lang='scss'>
.form-control {
  flex: 1;
  width: 100%;
  @include flex-column-start;
  .top-container {
    width: 100%;
    height: 66px;
    line-height: 66px;
    background: $bg-FormMune;
    box-sizing: border-box;
    @include flex-between;
    padding: 0px 24px 0px 40px;
    .left {
      color: $color-white;
      font-size: $fs-large-m;
      cursor: pointer;
    }
    .center {
      height: 66px;
      @include flex-center;
      color: $color-white;
      font-size: $fs-medium-m;
      margin-left: 140px;
      div {
        padding: 0px 20px;
        margin-left: 20px;
        cursor: pointer;
      }
      .active {
        height: 44px;
        line-height: 44px;
        background: rgb(92, 141, 255);
        border-radius: 4px;
      }
    }
    .btn-blue {
      background: $bg-FormMune !important;
      border: 1px solid $bg-white !important;
    }
    .el-button {
      border-radius: 4px !important;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: $bg-Phone;
    .left-container {
      width: 360px;
      padding: 30px 24px;
      box-sizing: border-box;
      background: $bg-white;
      box-shadow: 1px 0px 5px 0px rgb(31 31 31 / 8%);
      .row {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-PhoneTitle;
        margin-bottom: 14px;
        .form-title {
          margin-bottom: 12px;
          text-align: left;
        }
        .control {
          @include flex-between;
          flex-wrap: wrap;
          .control-details {
            @include flex-between;
            width: 148px;
            height: 34px;
            line-height: 34px;
            padding: 0px 5px 0px 10px;
            box-sizing: border-box;
            background: $bg-white;
            border: 1px solid $bg-DoopLightSnow;
            border-radius: 6px;
            margin-bottom: 16px;
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
    .main {
      flex: 1;
      margin: 70px 0px;
      @include flex-center;
      .phone {
        width: 330px;
        height: 702px;
        box-sizing: border-box;
        background: $bg-white;
        border-radius: 20px;
        box-shadow: 0px 0px 6px 5px rgb(31 31 31 / 0.06);
        padding: 15px;
        .inset-phone {
          width: 100%;
          height: 100%;
          border-radius: 12px;
          border: 1px solid $bg-Gainsboro;
          background: $bg-Phone;
          display: flex;
          flex-direction: column;
          .title {
            @include flex-start;
            height: 42px;
            box-sizing: border-box;
            background: $bg-white;
            border-radius: 12px 12px 0px 0px;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-grey;
            padding: 16px 10px 16px 0px;
            box-shadow: 0px 1px 3px 0px rgba(31, 31, 31, 0.08);
            img {
              width: 15px;
              height: 16px;
              cursor: pointer;
            }
            .title-name {
              flex: 1;
              .el-input {
                .el-input__inner {
                  text-align: center;
                  border: none;
                }
              }
            }
          }
          .inside-nothing {
            margin: 11px;
            flex: 1;
            border: 1px dashed $bg-FormDashed;
            .img {
              width: 24px;
              height: 24px;
              margin-top: 85px;
              margin-right: 84px;
            }
            p {
              text-align: center;
              margin-top: 24px;
              font-weight: 400;
              font-size: $fs-small-l;
              color: $color-PhoneTitle;
            }
          }
          .content {
            overflow-y: auto;
            @include scrollbar(0px);
            .component-container {
              margin: 8px 0px;
              position: relative;
            }
            .component-container-active {
              border: 1px solid $bg-FormMune;
            }
            .remove {
              display: none;
              position: absolute;
              top: 0;
              right: 0;
              width: 26px;
              height: 26px;
              z-index: 10;
              cursor: pointer;
              border-radius: 0px 0px 0px 26px;
              box-sizing: border-box;
              padding: 1px 0px 0px 6px;
              color: $color-white;
              background: $bg-FormMune;
            }
            .removeActive {
              display: block;
            }
            .text-container {
              height: 70px;
              font-size: $fs-small-l;
              padding: 0px 10px;
              background: $bg-white;
              @include flex-column-start;
              justify-content: center;
              .sub-title {
                color: $color-PhoneTitle;
                margin-bottom: 11px;
                @include flex-start;
                .star {
                  margin-left: 2px;
                  color: $color-PhoneStar;
                }
              }
              .phone-content {
                width: 100%;
                color: $color-LightGrey;
                @include flex-between;
              }
            }
            .cost-details {
              width: 100%;
              margin-top: 12px;
              @include flex-center;
              color: $color-PhoneCost;
            }
            .active {
              height: 85px;
              .phone-content {
                margin-bottom: 15px;
              }
            }
            .date-range {
              .add-row {
                @include flex-start;
                .text-container {
                  width: 50%;
                }
                &:nth-child(1) {
                  @include border-bottom-right(97%, 1px, $bg-Gainsboro);
                }
              }
              .text-container {
                margin: 0px;
              }
            }
            .total {
              padding-left: 10px;
              background: $bg-white;
              .text-container {
                height: 34px;
                margin: 0px;
                padding-left: 0px;
                .sub-title {
                  margin-bottom: 0px;
                }
              }
            }
            .upload-invoice {
              padding-bottom: 10px;
              .el-icon-plus {
                width: 48px;
                height: 48px;
                background: $bg-Phone;
                @include flex-center;
              }
            }
            .cost-details-component {
              .text-container {
                .sub-title {
                  margin-bottom: 0px;
                }
              }
            }
          }
          .container-component {
            .row {
              font-size: $fs-small-l;
              padding: 12px 0px;
              background: $bg-white;
              @include flex-column-start;
              justify-content: center;
              .text,
              .date-range,
              .upload-component,
              .cost-details-component {
                margin: 0px;
              }
              .sub-title {
                padding: 0px 10px;
                color: $color-PhoneTitle;
                margin-bottom: 11px;
                @include flex-start;
                .star {
                  margin-left: 2px;
                  color: $color-PhoneStar;
                }
              }
              .nothing-container {
                width: 100%;
                height: 48px;
                line-height: 48px;
                text-align: center;
                font-size: $fs-small-l;
                font-weight: 400;
                color: $color-ContainerComponent;
                background: $bg-Phone;
              }
              .container-content {
                width: 100%;
                background: $bg-Phone;
              }
              .text-container {
                .sub-title {
                  padding: 0;
                }
              }
            }
          }
        }
      }
    }
    .right-container {
      width: 360px;
      box-sizing: border-box;
      background: $bg-white;
      padding: 30px 23px;
      box-shadow: -1px 0px 5px 0px rgb(31 31 31 / 8%);
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label:before {
        display: none;
      }
      .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before,
      .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::after {
        content: "*";
        color: $bg-Required;
        margin-left: 4px;
      }
      .el-form-item__label {
        line-height: 22px;
      }
      .controlTitleName {
        font-size: $fs-medium-m;
        font-weight: 400;
        color: $color-Step;
        text-align: left;
        margin-bottom: 30px;
      }
      .radio {
        .radio-container {
          @include flex-start;
          .el-icon-close {
            margin-top: 8px;
            margin-left: 12px;
          }
        }
        .el-form-item__error {
          padding-top: 8px;
        }
        .radio-title {
          text-align: left;
          vertical-align: middle;
          font-size: $fs-small-l;
          color: $color-Form;
          box-sizing: border-box;
          margin-bottom: 6px;
          .star {
            margin-left: 4px;
            color: $color-PhoneStar;
          }
        }
        .add-radio {
          display: flex;
          .el-button {
            padding: 4px 0px 20px 0px;
          }
        }
      }
      .other-title {
        text-align: left;
        vertical-align: middle;
        font-size: $fs-small-l;
        color: $color-Form;
        box-sizing: border-box;
      }
      .required {
        @include flex-start;
        .el-form-item {
          margin-right: 16px;
        }
      }
    }
  }
  .print-container {
    flex: 1;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow: hidden;
    box-sizing: border-box;
    background: $bg-Phone;
    .print-content {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      border-radius: 8px;
      background: $bg-white;
      .print-top {
        height: 48px;
        @include flex-between;
        padding: 0px 20px;
        border-bottom: 1px solid $bg-ShallowLightSnow;
        .print-top-left {
          @include flex-start;
          .print-upload-title {
            font-size: 14px;
            font-weight: 400;
            color: $color-Step;
          }
          .upload {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            .el-icon-plus {
              color: $bg-DeepReddishBlue;
              border: 1px solid $bg-DeepReddishBlue;
              border-radius: 50%;
            }
            .none {
              .el-upload--picture-card {
                display: none;
              }
            }
            .el-upload-list__item:first-child {
              margin-top: 0px;
            }
            .el-upload__tip {
              margin: 0;
              margin-right: 11px;
              font-size: $fs-small-l;
              font-weight: 400;
              color: $color-UploadTips;
            }
          }
        }
        .print-top-right {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-Step;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-right: 6px;
          }
        }
      }
      .print-main {
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
        .print-main-left {
          height: 100%;
          padding: 10px 15px;
          border-right: 1px solid $bg-ShallowLightSnow;
          box-sizing: border-box;
          .print-title-row {
            min-height: 36px;
            line-height: 36px;
            margin-bottom: 10px;
            padding-left: 10px;
            text-align: left;
            font-size: $fs-small-l;
            color: $color-ChangeDepartmentHighTree;
            background: rgb(188, 210, 255);
          }
        }
        .print-main-right {
          flex: 1;
          height: 100%;
          padding: 20px;
          box-sizing: border-box;
          .print-img {
            text-align: left;
            overflow: hidden;
            border: 1px dashed $bg-FormDashed;
          }
          .print-nothing {
            height: 100%;
            border: 1px dashed $bg-FormDashed;
            @include flex-column-center;
            justify-content: center;
            img {
              margin-bottom: 14px;
              margin-right: 170px;
            }
          }
        }
      }
    }
  }
}
</style>
